module.exports = __webpack_public_path__ + "img/footer-icon-linked.fc85418b.png";